import { ZustandMainLoaderStore } from './types';

export const getMainLoaderPercentSelector = (state: ZustandMainLoaderStore) =>
  state.percent;

// ================================================================= ACTIONs =================================================================

export const setMainLoaderPercentAction = (state: ZustandMainLoaderStore) =>
  state.setPercent;
